import PARENT from '../types';

const SECONDARY_PARAMETER = `${PARENT}/SECONDARY_PARAMETER`;

export const SET_SECONDARY_PARAMETER = `${SECONDARY_PARAMETER}/SET`;

export default SECONDARY_PARAMETER;
